var projects: { image_location: { asset: string; description?: string }[], description: string, id?: number }[] = [
    {
        image_location: [{ asset: "25-004/1.jpg" },{ asset: "25-004/2.jpg" }],
        description: "Gaming Cat6 Data Drop"
    },
    {
        image_location: [{ asset: '25-005/1.jpg' }],
        description: "Fan Renewal"
    },
    {
        image_location: [{ asset: '25-005/2.jpg' },{ asset: '25-005/3.jpg' },{ asset: '25-005/4.jpg' },{ asset: '25-005/5.jpg' },{ asset: '25-005/6.jpg' },{ asset: '25-005/7.jpg' },{ asset: '25-005/8.jpg' },{ asset: '25-005/9.jpg' },{ asset: '25-005/10.jpg' }],
        description: "Home Light Renewal"
    },
    {
        image_location: [{ asset: '26-001/1.jpg' }, { asset: '26-001/2.jpg' }, { asset: '26-001/3.jpg' }, { asset: '26-001/4.jpg' }, { asset: '26-001/5.jpg' }],
        description: "Existing Home Fan Addition"
    },
    {
        image_location: [{ asset: '26-005/1.jpg' },{ asset: '26-005/2.jpg' },{ asset: '26-005/3.jpg' },{ asset: '26-005/4.jpg' },{ asset: '26-005/5.jpg' },{ asset: '26-005/6.jpg' }],
        description: "Commercial Lighting Renewal"
    },
];

export function initializeProjects() {
    for (let i in projects) {
        projects[i].id = parseInt(i) + 1;
    }
}

export function getProject(id: number) {
    return projects.find(p => p.id === id);
}
export function getProjects() {
    return projects;
}